import { HeroImage } from 'designsystem/components/2-molecules/HeroImage';
import { ConvertToPictureObject } from 'designsystem/utilities/convertToPictureObject';

export const HeroImageFeature: React.FC<Content.HeroImage> = ({ content, ...props }) => {
	const { picture, fullWidthImage, hideImageOnMobile, imageAspectRatio } = content?.properties ?? {};

	const pictureObject = ConvertToPictureObject(picture);

	return (
		<HeroImage
			image={pictureObject}
			fullWidthImage={fullWidthImage}
			hideImageOnMobile={hideImageOnMobile}
			imageAspectRatio={imageAspectRatio?.length ? imageAspectRatio : undefined}
			{...props}
		/>
	);
};
